import { isDebugMode } from '@/lib/utils'
import {
  capiDebug,
  capi as capiImpl,
  capiTrackDebug,
  capiTrack as capiTrackImpl,
  trackRegistrationEventsDebug,
  trackRegistrationEvents as trackRegistrationEventsImpl,
} from './actions'

export const capi = isDebugMode() ? capiDebug : capiImpl
export const capiTrack = isDebugMode() ? capiTrackDebug : capiTrackImpl
export const trackRegistrationEvents = isDebugMode()
  ? trackRegistrationEventsDebug
  : trackRegistrationEventsImpl

export type * from './actions'
